import { Controller } from "@hotwired/stimulus"
import { NavigationHelper } from "~/helpers/navigation_helper"

export default class extends Controller {
  static get targets() {
    return ["unreadCounter"]
  }

  connect() {
    // in case the user is on a Turbo preview of the page,
    // don't fetch new activity
    if (NavigationHelper.pageIsPreview()) { return }

    this.fetchActivity()
    this.startPollingActivity()
  }

  disconnect() {
    this.stopPollingActivity()
  }

  refresh() {
    // We use timeout to let other controllers finish their actions
    setTimeout(() => {
      this.fetchActivity()
    }, 300)
  }

  // Fetches the messages having activities since the passed timestamp.
  fetchActivity(since) {
    var since_param = ""

    if (since) {
      since_param = `?since=${since}`
    }

    fetch(`/messages/activity${since_param}`, {
      credentials: "same-origin",
      headers: { "Accept": "application/json" },
      cache: "no-cache",
    })
      .then(response => response.json())
      .then(activity => {
        if (activity.error != undefined || activity.data.outreach_enabled == false) {
          this.stopPollingActivity()
          return
        }

        this.updateCounter(this.unreadCounterTarget, activity.data.total_unread_inbox_messages)
      })
  }

  updateCounter(target, value) {
    if (value == 0) {
      target.classList.add("d-none")
    }
    else {
      if (value >= 100) { value = "100+" }

      target.innerHTML = value
      target.classList.remove("d-none")
    }
  }

  // This starts an interval that will poll for new events every
  // minute. Only events that happened during the passed minute
  // are requested.
  startPollingActivity() {
    this.activityPoller = setInterval(() => {
      // If the user hasn't allowed us to send him notifications, we make a more
      // generic request that is both easier on the server and can be cached
      // on the user's side.
      if (Notification.permission != "granted") {
        this.fetchActivity(Math.floor(Date.now() / 1000) - 60)
      } else {
        this.fetchActivity()
      }
    }, 60000)
  }

  // Stops the interval when the user leaves the controller.
  stopPollingActivity() {
    if (this.activityPoller) {
      clearInterval(this.activityPoller)
    }
  }
}
